import React, { forwardRef } from "react";
import { days, hours, daysEven } from "../../datas/timeDatas";
import ScheduleHeader from "../ScheduleHeader";

const BodyDownload = forwardRef(({ schedules = [] }, ref) => {
  const containsLightAcademy = (text) => {
    if (!text) return false;
    return text.toLowerCase().includes("light academy");
  };

  return (
    <div className="d-flex">
      <div className="schedule-table-container-download">
        <div
          className="table-hour-gradient"
          style={{ display: "inline-block", width: "auto" }}
        >
          <table ref={ref} className="schedule-table">
            <thead className="">
              <tr>
                <th className="schedule-th-empty"></th>
                {days.map((day) => (
                  <th
                    key={day}
                    className="schedule-th-day me-2 position-sticky z-0"
                  >
                    <ScheduleHeader day={day} />
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {hours.length > 0 &&
                hours.map((hour) => (
                  <tr key={hour}>
                    <td className="hour-cell">{hour}</td>
                    {days.map((day) => {
                      const daySchedule =
                        schedules.length > 0
                          ? schedules.find((d) => d.day == day)
                          : null;
                      const classDataDay = [
                        ...(daySchedule?.schedule?.morning || []),
                        ...(daySchedule?.schedule?.noon || []),
                      ];

                      const digitTime = hour?.split(":")[0];
                      const classData = classDataDay?.filter((c) => {
                        const startHour = c?.start_time?.split(":")[0];
                        const isSameHour = startHour === digitTime;
                        const isLightAcademy =
                          containsLightAcademy(c?.class_name) ||
                          containsLightAcademy(c?.instruktur_name);
                        return isSameHour && !isLightAcademy;
                      }) || [];

                      const dayColor = daysEven.includes(day)
                        ? "var(--neutral-light-blue)"
                        : "var(--neutral-white)";
                      if (!classData || classData.length === 0) {
                        return (
                          <td
                            key={`${day}-${hour}-empty`}
                            className="empty-cell"
                            style={{ background: dayColor, padding: "10px" }}
                          ></td>
                        );
                      }
                      return (
                        <td
                          key={`${day}-${hour}-class-cell`}
                          className="class-cell text-start"
                          style={{
                            background: dayColor,
                            color: "#fff",
                            padding: "10px",
                          }}
                        >
                          {classData?.map((c, index) => (
                            <div
                              key={`${day}-${hour}-${index}`}
                              className="class-details"
                            >
                              <div className="class-header">
                                <span className="class-time">
                                  {c.start_time} - {c.end_time}
                                </span>
                                {c?.club_name && (
                                  <div className="class-club">
                                    <i className="bi bi-geo-alt-fill"></i>
                                    <span>{c.club_name}</span>
                                  </div>
                                )}
                                <span
                                  className="class-dot"
                                  style={{
                                    background: c.bg_color,
                                    marginRight: "5px",
                                  }}
                                ></span>
                                <span className="class-name">
                                  {c.class_name}
                                </span>
                              </div>
                              <div
                                className="class-instructor"
                                style={{ marginTop: "5px" }}
                              >
                                <span>{c?.instruktur_name}</span>
                              </div>
                            </div>
                          ))}
                        </td>
                      );
                    })}
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
});

export default BodyDownload;
